import {ADD_PARAMETERS} from "../actions/ParametersActions";

const initialState = {
    parameters: {}
};

const ParametersReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PARAMETERS:
            if (typeof action.payload['search-params'].departureCity === 'undefined') {
                action.payload['search-params'].departureCity = action.payload['search-params'].departureAirport;
            }
            if (typeof action.payload['search-params'].arrivalCity === 'undefined') {
                action.payload['search-params'].arrivalCity = action.payload['search-params'].arrivalAirport;
            }

            return {...state, parameters: action.payload};
        default:
            return state
    }
};

export default ParametersReducer;



// WEBPACK FOOTER //
// ./src/reducers/ParametersReducer.js